// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"2cd7fea0","865":"55925d12"}[chunkId] + ".chunk.css";
};